import { CircularProgress } from '@mui/material';

export function Loading() {
  return <CircularProgress sx={{ alignSelf: 'center', marginTop: '20px' }} />;
}
